import m from "../../es2015/themes/amcharts";
window.am4themes_amcharts = m;


//////////////////
// WEBPACK FOOTER
// ./themes/amcharts.js
// module id = null
// module chunks = 